const ufOptions = [
  {
    state: 'AC',
  },
  {
    state: 'AL',
  },
  {
    state: 'AM',
  },
  {
    state: 'AP',
  },
  {
    state: 'BA',
  },
  {
    state: 'CE',
  },
  {
    state: 'DF',
  },
  {
    state: 'ES',
  },
  {
    state: 'GO',
  },
  {
    state: 'MA',
  },
  {
    state: 'MG',
  },
  {
    state: 'MS',
  },
  {
    state: 'MT',
  },
  {
    state: 'PA',
  },
  {
    state: 'PB',
  },
  {
    state: 'PE',
  },
  {
    state: 'PI',
  },
  {
    state: 'PR',
  },
  {
    state: 'RJ',
  },
  {
    state: 'RN',
  },
  {
    state: 'RS',
  },
  {
    state: 'RO',
  },
  {
    state: 'RR',
  },
  {
    state: 'SC',
  },
  {
    state: 'SE',
  },
  {
    state: 'SP',
  },
  {
    state: 'TO',
  },
];

export default ufOptions;
